import { render, staticRenderFns } from "./Transform.vue?vue&type=template&id=4c00696e&lang=pug&"
import script from "./Transform.vue?vue&type=script&lang=js&"
export * from "./Transform.vue?vue&type=script&lang=js&"
import style0 from "./Transform.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports